import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';

const InputSelectionDropdown = ({ value, onChange, options, optionLabel, placeholder }) => {

    const [optionsList, setOptionsList] = useState([]);

    useEffect(() => {
        setOptionsList(options);
    }, [options]);

    return (
                <Dropdown 
                                value={value} 
                                onChange={onChange} 
                                options={optionsList} 
                                optionLabel={optionLabel} 
                                placeholder={placeholder} 
                                className="w-full md:w-14rem" 
                                checkmark={true} 
                                highlightOnSelect={false} 
                            />
    );
};

export default InputSelectionDropdown;
